import React, { Component } from 'react';
import * as Connections from '../../../utils/Connections';
class Line extends Component{
    render(){
        const {messageLine,openChat}=this.props
        return(
            <div onClick={()=>openChat && openChat()} style={{cursor:'pointer',display:'flex',alignItems:'center',marginBottom:5,height:35,boxShadow:'1px 1px 1px 1px lightgrey'}}>
                <div>
                    <img alt="icon" style={{width:20,marginLeft:5,marginRight:5}} src="https://khula.co.za//images/agric_logo.svg"/>
                </div>
                <div style={{textTransform:"capitalize"}}>{messageLine && `${messageLine.farmerName} ${messageLine.farmerSurname}`}</div>
            </div>
        )
    }
}
export default class ViewChats extends Component{
    state={
        messageLines:[]
    }
    componentDidMount() {
        this.getMessages();
        Connections.socket.on("newMessage",()=>{
          this.getMessages();
        })
    }
    getMessages(){
        Connections.getMessageLines().then(({messages:messageLines})=>{
            this.setState({messageLines})
        })
    }
    render(){
        const {messageLines}=this.state
        return(
            <div>
                {
                    messageLines && messageLines.map((item,index)=><Line key={index} messageLine={item} openChat={()=>this.props.openChat(`${item.farmerName} ${item.farmerSurname}`,item.farmerId)} />)
                }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/HomePageBabies/BabyItems/ViewChats.js